module.exports = __webpack_public_path__ + "theme/assets/img/ed20c9bd81daabe08420d676a039a64d.png";